export default {
  common: {
    welcome: 'Welcome',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    search: 'Search',
    retry: 'Retry'
  },
  menu: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    support: 'Technical Supports',
    about: 'About Us'
  },
  products: {
    intelligentChannel: 'Intelligent Channel Systems',
    middleware: 'IoT Middleware',
    sensor: 'Sensors & Components',
    learnMore: 'Learn More',
    fetchFailed: 'Failed to fetch product data',
    allTypes: 'All Types',
    productType: 'Product Type',
    noProducts: 'No products available',
    loadFailed: 'Failed to load products, please refresh and try again'
  },
  homepage: {
    learnMore: 'Learn More',
    productCenter: 'Products',
    latestProduct: 'LATEST PRODUCT'
  },
  chatbot: {
    onlineService: 'Online Service',
    title: 'Online Customer Service',
    welcomeMessage: 'Hello! I am the intelligent customer service. How can I help you?',
    placeholder: 'Please enter your question...',
    send: 'Send',
    sending: 'Sending...',
    searching: 'Searching for you...'
  },
  pagination: {
    previous: 'Previous',
    next: 'Next'
  },
  // 添加footer模块
  footer: {
    slogan: 'Innovation Makes Us Unique',
    copyright: '2018 Copyright © Fabet Electric (Shanghai) Co., Ltd. ICP No. 11031202-1',
    security: 'Shanghai Public Network Security No. 31010402006823',
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    techSupport: 'Tech Support',
    contact: 'About Us',
    phone: 'Phone: ',
    email: 'Email: '
  },
  aboutPage: {
    title: 'About Us',
    subtitle: 'Company Profile',
    learnMore: 'Learn More',
    buildingAlt: 'Company Building',
    description: "FABET started with door automation systems, and its core products such as door openers have gradually grown with over 50 years of development and global product application experience from research and development centers in Germany, Italy, and other countries. Based on the widespread global application of door automation systems and the integration of increasingly mature AI technology, FABET's technical team has launched AIOT products focusing on scenarios such as door automation terminals, smart passage, and smart parks. FABET is willing to work with global partners to create, co build, share, and achieve win-win results."
  },
  languages: {
    zh: 'Chinese',
    en: 'English'
  },
  productDetail: {
    specifications: 'Specifications',
    description: 'Description',
    applications: 'Applications',
    technicalParams: 'Technical Parameters',
    relatedProducts: 'Related Products',
    back: 'Back',
    dimensionDetails: 'Dimension Details',
    dimensionImage: 'Product Dimension Image',
    noProduct: 'Product not found',
    loadError: 'Failed to load product details',
    noProductId: 'Product ID does not exist',
    noProductData: 'Product data not found',
    loadFailed: 'Failed to load, please try again',
    paramName: 'Parameter Name',
    paramValue: 'Parameter Value',
    feature1: 'Flexible Networking',
    feature2: 'Rich Protocols',
    feature3: 'Industrial Design',
    feature4: 'Rich Interfaces'
  },
  techSupport: {
    resourcesDownload: 'Resources Download',
    manualDownload: 'Manual Download',
    softwareDownload: 'Software Download',
    download: 'Download',
    noSoftware: 'No software resources available',
    noManual: 'No manual resources available',
    faq: 'Frequently Asked Questions',
    question: 'Q',
    answer: 'A',
    noFaq: 'No FAQs available',
    technicalDocs: 'Technical Documents Download',
    noDocuments: 'No technical documents available',
    downloadFailed: 'Download failed, please try again'
  },
  solutions: {
    allTypes: 'All Types',
    solutionType: 'Solution Type',
    solution: 'Solution',
    noSolutions: 'No solutions available',
    loadFailed: 'Failed to load solutions, please refresh and try again',
    defaultDescription: 'Professional solutions providing comprehensive technical support and service guarantees.',
    professionalCustom: 'Professional Customization',
    efficientReliable: 'Efficient & Reliable',
    loadingDetail: 'Loading solution details...',
    tableFormatError: 'Table data format error',
    imageUrlInvalid: 'Image URL invalid',
    noDetailContent: 'No detailed content available, please contact administrator to add paragraph content',
    noSolutionId: 'Solution ID does not exist',
    noSolutionData: 'Solution data not found',
    loadDetailFailed: 'Failed to load, please try again',
    techLeading: 'Technology Leading',
    servicePerfect: 'Perfect Service'
  },
  contact: {
    companyIntro: 'Company Introduction',
    values: 'Values',
    colorMeanings: 'Color Meanings',
    companyBuilding: 'Company Building',
    showFormHint: 'Click or hover to show feedback form',
    contactUs: 'Contact Us',
    messageFeedback: 'Message Feedback',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    namePlaceholder: 'Please enter your name',
    emailPlaceholder: 'Please enter your email',
    phonePlaceholder: 'Please enter your phone',
    messagePlaceholder: 'Please enter your message',
    submitting: 'Submitting...',
    submit: 'Submit Message',
    submitSuccess: 'Message submitted successfully!',
    submitError: 'Submission failed, please try again later.'
  }
}